import { Heart } from "lucide-react";
import Link from "next/link";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const FavoritesButton = () => {
  return (
    <Link
      href="/account/favorites"
      aria-label="Favorilerim"
      onClick={() => trackGeneric("header_favorites", "click")}
      className="flex items-center gap-2 font-medium text-sm hover:text-main transition-all duration-300 ease-in-out"
    >
      <Heart className="size-6 md:size-4.75" />
      <p className="hidden md:block">Favorilerim</p>
    </Link>
  );
};

export default FavoritesButton;
